import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Twitter, Linkedin, Github, Mail } from "lucide-react";
import logo from "../../assets/access wealth logo icon.png";
import logo2 from "../../assets/access wealth logo icon light.png";
import { useTheme } from "@/context/ThemeContext";

export default function Footer() {
  const { theme } = useTheme();
  return (
    <footer className="border-t border-slate-200 dark:border-slate-800 bg-white/50 dark:bg-slate-950/50 mt-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <div className="flex items-center gap-2">
              <div className="grid h-12 w-10 place-items-center  overflow-hidden">
                {theme == "dark" ? (
                  <>
                    <img
                      src={logo2}
                      alt="AccessWealth"
                      className="h-full w-full object-cover"
                    />
                  </>
                ) : (
                  <>
                    <img
                      src={logo}
                      alt="AccessWealth"
                      className="h-full w-full object-cover"
                    />
                  </>
                )}
              </div>
              <span className="font-display text-lg font-bold tracking-tight text-slate-900 dark:text-white">
                AccessWealth
              </span>
            </div>
            <p className="mt-3 text-sm text-slate-600 dark:text-slate-400 max-w-xs">
              A lifelong financial operating system for individuals and
              families. Track, grow, secure — and pass it on.
            </p>
          </div>
          {[
            {
              title: "Product",
              links: [
                { label: "Calculators", to: "/calculators" },

                { label: "Pricing", to: "/pricing" },
              ],
            },
            {
              title: "Company",
              links: [
                { label: "About", to: "/" },
                { label: "Contact", to: "/" },
              ],
            },
            {
              title: "Legal",
              links: [
                { label: "Privacy", to: "/privacy" },
                { label: "Terms", to: "/terms" },
                { label: "Security", to: "/security" },
                { label: "Account Deletion", to: "/account_deletion" },
                // { label: "DPDP Compliance", to: "/" },
              ],
            },
          ].map((col) => (
            <div key={col.title}>
              <div className="text-xs font-bold uppercase tracking-widest text-slate-500 dark:text-slate-400 mb-3">
                {col.title}
              </div>
              <ul className="space-y-2">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-slate-600 dark:text-slate-300 hover:text-emerald-600"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 pt-6 border-t border-slate-200 dark:border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500 dark:text-slate-400">
            © 2026 AccessWealth. Built with trust, designed for legacy.
          </p>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            Made in India · secure
          </p>
        </div>
      </div>
    </footer>
  );
}
